import { Box, Button, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Sidebar from './Sidebar'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { getCategory, updateCategory } from '../Store/ActionCreators/CategoryActionCreator'

export default function UpdateCategory() {
    const [data, setData] = useState({
        name : '',
        slug : ''
    })
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const categoryList = useSelector((state)=> state.CategoryStateData)
    const {_id} = useParams()
    function getData(e){
        const name = e.target.name
        const value = e.target.value
        setData((old)=>{
            return{
                ...old,
                [name]: value
            }
        })
    }
    function postData(e){
        e.preventDefault()
        const item = {
            _id : _id,
            name : data.name,
            slug: data.name
        }
        dispatch(updateCategory(item))
        navigate("/admincategory")
    }
    useEffect(()=>{
        const foundData = categoryList.find((item) => item._id === _id);
        if (foundData) {
            setData(foundData);
        }   
  }, [categoryList, _id]);
  return (
    <>
        <Box sx={{display:"flex"}}>
            <Sidebar/>
            <Box className="boxStyle">
                <h4 className='bg-success text-light text-center p-1 rounded mt-3' style={{
              fontFamily: "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif"
            }}>Update Category Form</h4>
                    <div className="Category_Form">
                         <h4>Category Update From</h4>
                        <form onSubmit={postData}>
                            <div className="mb-5">
                                <TextField
                                    label="Category Name *"
                                    variant="standard"
                                    placeholder="Enter Category name"
                                    color="success"
                                    fullWidth
                                    name='name'
                                    onChange={getData}
                                    value={data.name}
                                />
                            </div>
                            <Button type='submit' className='bg-success w-100 text-light'>Update</Button>
                        </form>
                    </div> 
            </Box>
        </Box>
    </>
  )
}
